module.exports = __webpack_public_path__ + "img/no.f4759d0d.png";